/**
 * MockBanner - 開発環境専用表示バナー
 *
 * @file MockBanner.tsx
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 開発環境でのみ表示されるシンプルな「開発中」表示。
 * ヘッダー上辺に赤い5pxラインと右上に小さく「開発中」のテキストを固定表示。
 */

import React from 'react';

const MockBanner: React.FC = () => {
  // 本番環境では非表示
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '5px',
        backgroundColor: 'rgb(244, 67, 54, 0.9)', // 赤色
        zIndex: 1100, // 既存の最高値1001を上回る
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: '0',
          right: '5px',
          fontSize: '10px',
          color: '#fff',
          backgroundColor: 'rgb(244, 67, 54, 0.9)',
          padding: '0 5px',
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
      >
        開発中
      </span>
    </div>
  );
};

export default MockBanner;
